import React from 'react'
import * as C from "../componentsM/index"
import { Link } from 'react-router-dom'

const MYPProjects = () => {

    return (
        <>

            <C.Hero title={"MYP PROJECTS"}
                image={"/hero/11.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>

                <h1 className='text-xl md:text-2xl'>
                Community Project
                </h1>

                <p>The Community Project focuses on community and service, encouraging students to explore their right and responsibility to implement service as action in the community. The Community Project gives students an opportunity to develop awareness of needs in various communities and address those needs through service learning. As a consolidation of learning, the community project engages in a sustained, in-depth enquiry leading to service as action in the community.</p>

                <h1 className='text-xl md:text-2xl'>
                Personal Project
                </h1>

                <p>All students in the final year of the Middle Year’s Programme are required to engage in and complete the Personal Project as this project is the key to attaining the <Link to={"/not"} className='text-myBlue/60'>MYP Certificate.</Link> </p>



                </div>
            </section>

        </>

    )
}

export default MYPProjects